import { useRouter } from 'vue-router';

export default function useNavigateTo() {
  // Use plugins
  const router = useRouter();

  // Methods
  const navigateToLogin = () => router.push('/login');
  const navigateToRecovery = () => router.push('/recover');

  // Expose methods
  return {
    // Methods
    navigateToLogin,
    navigateToRecovery
  };
}